import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Filter out browser extension errors
    const errorMessage = error?.message || '';
    const errorStack = error?.stack || '';
    const errorString = String(error);
    
    // Comprehensive check for browser extension errors
    const isExtensionError = 
      (errorMessage.includes('Request timeout') && 
       (errorMessage.includes('Distributor') ||
        errorMessage.includes('appSettingsDistributor') ||
        errorMessage.includes('lettersVoicesDistributor') ||
        errorMessage.includes('dictionariesDistributor') ||
        errorMessage.includes('availableLanguagesDistributor') ||
        errorMessage.includes('availableTextCheckLanguagesDistributor') ||
        errorMessage.includes('dictateStateDistributor') ||
        errorMessage.includes('predictionDistributor') ||
        errorMessage.includes('speechVoicesDistributor') ||
        errorMessage.includes('userDistributor') ||
        errorMessage.includes('wordsDistributor') ||
        errorMessage.includes('textCheckersDistributor') ||
        errorMessage.includes('topicsDistributor') ||
        errorMessage.includes('getDictionariesByLanguageId') ||
        errorMessage.includes('isMathOcrAvailable') ||
        errorMessage.includes('isPredictionAvailable') ||
        errorMessage.includes('isDictateAvailable') ||
        errorMessage.includes('DefineExpirationForLanguagePacks') ||
        errorMessage.includes('getValue'))) ||
      (errorStack.includes('bundle.js') && 
       (errorMessage.includes('Request timeout') || errorMessage.includes('Distributor'))) ||
      errorString.includes('Distributor') ||
      errorString.includes('Request timeout');
    
    if (isExtensionError) {
      // Silently ignore extension errors - don't trigger error state
      return null;
    }
    
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Filter out browser extension errors
    const errorMessage = error?.message || '';
    const errorString = String(error);
    
    const isExtensionError = 
      (errorMessage.includes('Request timeout') && 
       (errorMessage.includes('Distributor') ||
        errorMessage.includes('appSettingsDistributor') ||
        errorMessage.includes('lettersVoicesDistributor') ||
        errorMessage.includes('dictionariesDistributor') ||
        errorMessage.includes('availableLanguagesDistributor') ||
        errorMessage.includes('availableTextCheckLanguagesDistributor') ||
        errorMessage.includes('dictateStateDistributor') ||
        errorMessage.includes('predictionDistributor') ||
        errorMessage.includes('speechVoicesDistributor') ||
        errorMessage.includes('userDistributor') ||
        errorMessage.includes('wordsDistributor') ||
        errorMessage.includes('textCheckersDistributor') ||
        errorMessage.includes('topicsDistributor') ||
        errorMessage.includes('getDictionariesByLanguageId') ||
        errorMessage.includes('isMathOcrAvailable') ||
        errorMessage.includes('isPredictionAvailable') ||
        errorMessage.includes('isDictateAvailable') ||
        errorMessage.includes('DefineExpirationForLanguagePacks') ||
        errorMessage.includes('getValue'))) ||
      errorString.includes('Distributor') ||
      errorString.includes('Request timeout');
    
    if (!isExtensionError) {
      console.error('Error caught by boundary:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="text-center p-8">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Noe gikk galt</h1>
            <p className="text-gray-600 mb-4">Vennligst last inn siden på nytt for å prøve igjen.</p>
            <button
              onClick={() => window.location.reload()}
              className="btn-primary"
            >
              Last inn siden på nytt
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

